/** Google Tag Manager container for radar.aquivolabs.com */
export const GTM_CONTAINER_ID = "GTM-PC9WCLCX";

/** Per-origin; separate from marketing site */
export const COOKIE_CONSENT_STORAGE_KEY = "radar.cookieConsent";
